module.exports = __webpack_public_path__ + "img/box_1.9d754d13.svg";